import React, { useState } from "react";
import API from "../../api";

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store";
import { connect } from "react-redux";

import TextInputField from "../../components/textInput";
import Button from "../../components/button";
import { useLanguage } from "@languages/index";

const BrandIndex = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.settings };
  const fetchBrand = () => {
    API.Brand.show({ brandToken: props.auth.token })
      .then((response) => {
        setBrand(response.data.brand);
      })
      .catch(() => {
        props.showModal({
          text: languageTexts.password_text_1,
        });
      });
  };

  const handleChange = async (target, value) => {
    const formCopy = { ...brand };
    formCopy[`${target}`] = value;
    await setBrand(formCopy);
  };

  const [brand, setBrand] = useState<any>(() => {
    fetchBrand();
  });

  const renderPageTitle = () => {
    return (
      <div className="text-2xl font-bold tracking-tighter flex justify-center mt-12">
        {languageTexts.password_text_2}
      </div>
    );
  };

  const renderForm = () => {
    const formTitleStyle = {
      fontSize: "16px",
      lineHeight: "19px",
      letterSpacing: "-0.05em",
      fontWeight: 700,
    };

    const formDescStyle = {
      fontSize: "14px",
      lineHeight: "17px",
      letterSpacing: "-0.05em",
      color: "#999999",
    };

    return (
      <div className="flex flex-col my-10">
        <div className="at-tag-form">
          <div className="text-lg font-bold tracking-tighter">
            {languageTexts.password_text_2}
          </div>
          <div className="text-base tracking-tighter text-[#999] mt-2">
            {languageTexts.password_text_3}
          </div>
          <div className="form-input mt-4 mb-7">
            <TextInputField
              bordered
              value={brand?.passwordOriginal ?? ""}
              placeholder={languageTexts.input}
              onChangeText={(value) => {
                handleChange(`passwordOriginal`, value);
              }}
              type="password"
            />
          </div>

          <div className="text-base tracking-tighter text-[#999] mt-2">
            <span style={formDescStyle}>{languageTexts.password_text_4}</span>
          </div>
          <div className="form-input mt-4 mb-7">
            <TextInputField
              bordered
              value={brand?.passwordNew ?? ""}
              placeholder={languageTexts.input}
              type="password"
              onChangeText={(value) => {
                handleChange(`passwordNew`, value);
              }}
            />
          </div>

          <div className="text-base tracking-tighter text-[#999] mt-2">
            <span style={formDescStyle}>{languageTexts.password_text_5}</span>
          </div>
          <div className="form-input mt-4 mb-7">
            <TextInputField
              bordered
              value={brand?.passwordNewConfirm ?? ""}
              placeholder={languageTexts.input}
              type="password"
              onChangeText={(value) => {
                handleChange(`passwordNewConfirm`, value);
              }}
            />
          </div>

          <div className="form-submit-button">
            <Button
              textColor={"WHITE"}
              buttonColor={"BLACK"}
              text={languageTexts.save2}
              onClick={() => {
                let params = {};

                if (!brand.passwordOriginal) {
                  props.showModal({ text: languageTexts.password_text_3 });
                  return false;
                }
                if (!brand.passwordNew) {
                  props.showModal({ text: languageTexts.password_text_4 });
                  return false;
                }
                if (!brand.passwordNewConfirm) {
                  props.showModal({
                    text: languageTexts.password_text_6,
                  });
                  return false;
                }

                params["passwordOriginal"] = brand.passwordOriginal;
                params["passwordNew"] = brand.passwordNew;
                params["passwordNewConfirm"] = brand.passwordNewConfirm;

                API.Brand.update({
                  brandToken: props.auth.token,
                  ...params,
                })
                  .then((response) => {
                    let arr = {
                      text: response.data.message,
                    };

                    if (response.data.title.length) {
                      arr["title"] = response.data.title;
                    }

                    props.showModal(arr);
                  })
                  .catch((error) => {
                    props.showModal({
                      text: error.message,
                    });
                  })
                  .finally(() => {
                    fetchBrand();
                    props.onUpdate ? props.onUpdate() : null;
                  });
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="mx-auto w-full" style={{ maxWidth: "385px" }}>
      <div className="px-5 mx-auto w-full">
        {renderPageTitle()}
        {renderForm()}
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(BrandIndex);
